(function(){

    class SystemTotalBet extends PIXI.Container{
        constructor(){
            super();
		}
       
        //////////////////////////////////////////////////
        initialise() {
        };

		////////////////////////////////////////////////////////
		init( configEvent ) {};
	}

    //////////////////////////////////////////////////
    create = function(json) {
        return new SystemTotalBet();
    };

    //////////////////////////////////////////////////
    initialise = function(json, container, resources) {
        container.initialise();        
    };

    //////////////////////////////////////////////////
    getFilesRequired = function(json) {
        return [ "", "" ];
    };

    resourceManager.registerObjectType("systemTotalBet", create, initialise, getFilesRequired);
}());
